export default __webpack_public_path__ + "static/0-76cfe16bd9e6e21455aeff580c26b4b3.jpg";